import { render } from "./QuestionNestedDraggableParentComponent.vue?vue&type=template&id=ef7e7b20"
import script from "./QuestionNestedDraggableParentComponent.vue?vue&type=script&lang=js"
export * from "./QuestionNestedDraggableParentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__